import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { EjendomSearchResponse, EjendomSted, MatrikelSted } from 'src/app/api/models';
import { LokaliteterService } from '../../../api/services';
import { NotificationService } from '../../notifications/notification.service';
import { TekstResourcePipe } from '../../pipes/tekstresource.pipe';
import { Matrikel } from '../../services/geosearch/models/matrikel';
import { MatrikelsoegningService } from './services/matrikelsoegning.service';

@Component({
  selector: 'bom-matrikelsoegning',
  templateUrl: './matrikelsoegning.component.html',
  styleUrls: ['./matrikelsoegning.component.scss'],
})
export class MatrikelsoegningComponent implements OnInit, OnDestroy {
  @Output()
  searchMatrikelSted = new EventEmitter<EjendomSted>();

  @Output()
  searchButtonToggle = new EventEmitter<boolean>();

  @Output()
  valgtStedLoadingToggle = new EventEmitter<boolean>();

  @Input()
  searchClicked: Observable<any>;

  searchSubscription: Subscription;

  selectedMatrikel: Matrikel;

  constructor(
    public matrikelsoegningService: MatrikelsoegningService,
    public lokaliteterService: LokaliteterService,
    private notificationService: NotificationService,
    private tekstResourcePipe: TekstResourcePipe
  ) { }

  ngOnInit(): void {
    this.searchSubscription = this.searchClicked.subscribe(() => {
      this.searchMatrikel();
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  onValueSelected(matrikel: Matrikel) {
    this.selectedMatrikel = matrikel;
    this.searchButtonToggle.emit(!!this.selectedMatrikel);
    this.valgtStedLoadingToggle.emit(!!this.selectedMatrikel);

    if (this.selectedMatrikel) {
      this.searchMatrikel();
    }
  }

  onValueActivated() {
    this.valgtStedLoadingToggle.emit(!!this.selectedMatrikel);
    this.searchMatrikel();
  }

  searchMatrikel() {
    if (!this.selectedMatrikel) {
      return;
    }
    const jordstykke_id = this.selectedMatrikel.jordstykke_id;
    this.lokaliteterService
      .getEjendomstedByJordstykkeId(jordstykke_id)
      .subscribe((response: EjendomSearchResponse) => {
        if (response.externalCallSuccess) {
          this.searchMatrikelSted.emit(response.ejendom);
        } else {
          this.notificationService.warn(
            this.tekstResourcePipe.transform('Fejl.Notifikation.EksternSystem.Error'),
            null,
            response.correlationId
          );
        }
      });
  }

  private fireSearchMatrikelSted() {
    const matrikelSted = this.createMatrikelSted(this.selectedMatrikel);
    this.searchMatrikelSted.emit(matrikelSted);
  }

  private createMatrikelSted(matrikel: Matrikel): MatrikelSted {
    return {
      type: 'MatrikelSted',
      matrikelNummer: matrikel.matrikelnummer,
      landsEjerLavsNavn: matrikel.ejerlavsnavn,
      landsEjerlavsKode: parseInt(matrikel.ejerlavskode, 10),
    };
  }
}
